import { IEventRegistrationForm } from "@models/EventRegistrationForm.model";
import { Draft } from "./Draft.util";
import { getCalculateProgressParams } from "./getCalculateProgressParams";

export const getEventsProgressParamsUtil = (
  draft: Draft<IEventRegistrationForm>
) => {
  const requiredFieldsValues: any[] = [];

  (draft.events || []).forEach((event) => {
    const { date, description, image, time, title, location, entrance } =
      event || {};
    requiredFieldsValues.push(
      ...[date, description, image, time, title, location, entrance]
    );
  });
  return getCalculateProgressParams(requiredFieldsValues);
};
